import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "user/order_notes",
    object: "order_note",
    status: "",
    header: [      
      { text: "Date", value: "date_note" },
      { text: "Company", value: "company" },
      { text: "Store", value: "store" },
      { text: "Guard", value: "guard" },
      { text: "Comments", value: "comment" },
      { text: "Status", value: "status" }
      // { text: "Actions", value: "actions", sortable: false },
    ],
    roles: [],
    options: {
      sortBy: ["id"],
      sortDesc: [true],
    },
    total:0,
    page:1
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
    getList({ commit, state }, options) {
      return new Promise((resolve, reject) => {
        commit("request");

        let filter = {
          search: "",
          limit: 10,
          page: 1,
        };

        if (options) {
          for (let i in options) {
            filter[i] = options[i];
          }

          commit("options", options);
          filter["limit"] = options.itemsPerPage;
          filter["page"] = options.page;
          filter["search"] = options.search;
          filter["sorting_column"] =
            options.sortBy.length > 0 ? options.sortBy[0] : "";
          filter["sorting_order"] =
            options.sortDesc.length > 0
              ? options.sortDesc[0]
                ? "asc"
                : "desc"
              : "";
        }

        axios
          .get(config.api_url + state.endpoint, { params: filter })
          .then((response) => {
            console.log(response);
            commit("success", {
              list: response.data,
              total: parseInt(response.headers["pagination-count"]),
            });
            resolve(response.data);
          })
          .catch((err) => {
            commit("error");
            reject(err);
          });
      });
    },
  },
  getters: {
    ...genericStore.getters,
  },
};
